// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#story-mode-direct-costs[data-v-e5aa67e4]{margin-left:0}", ""]);
// Exports
module.exports = exports;
